<template>
  <div>
    <!-- 列表页面 -->
    <div class="container" v-if="!showEdit">
      <sticky-top>
        <div class="header">
          <div class="title">参与玩家</div>
          <div class="header-right" v-auth="'搜索用户'">
            <lin-search @query="onQueryChange" ref="searchKeyword" />
            <span class="back" @click="back">
              <i class="iconfont icon-fanhui"></i> 返回
            </span>
          </div>
        </div>
      </sticky-top>
      <!-- 表格 -->
      <lin-table
        ref="table"
        :tableColumn="tableColumn"
        :tableData="tableData"
        :operate="operate"
        v-loading="loading"></lin-table>

      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          @current-change="handleCurrentChange"
          :background="true"
          :page-size="pageCount"
          :current-page="currentPage"
          v-if="refreshPagination"
          layout="prev, pager, next, jumper"
          :total="total_nums">
        </el-pagination>
      </div>
    </div>

  </div>
</template>

<script>
import prjPlayerApi from '../../../models/project_player'
import LinTable from '@/components/base/table/lin-table'
import LinSearch from '@/components/base/search/lin-search'
import TableImage from '../../../../Common/components/TableImage'

export default {
  components: {
    LinTable,
    LinSearch,
    TableImage,
  },
  data() {
    return {
      tableColumn: [
        {
          prop: 'player.head || player.channel_head',
          label: '头像',
          style: {width:"40px",height:"40px"},
          component: TableImage,
        },
        { prop: 'player.name', label: '名字' },
        { prop: 'player.uid', label: '编号' },
        { prop: 'player.phone', label: '电话' },
        { prop: 'player.address', label: '地址' },        
        { prop: 'addtion', label: '加权' },
        { prop: 'count', label: '抽奖次数' },
      ],
      tableData: [],
      operate: [],
      showEdit: false,
      dataID: 1,

      refreshPagination: true, // 页数增加的时候，因为缓存的缘故，需要刷新Pagination组件
      total_nums: 0, // 分组内的总数
      currentPage: 1, // 默认获取第一页的数据
      pageCount: 10, // 每页10条数据
      searchKeyword: '',

      showPreview: false,
      selectedRow: {},
    }
  },
  async created() {
    this.loading = true
    this.getDatas()
    this.operate = []
    this.loading = false
  },
  methods: {
    onQueryChange(query) {
      // 处理带空格的情况
      this.searchKeyword = query.trim()
      this.getDatas()
    },
    onFilterDisplay(value) {
      this.getDatas()
    },
    async getDatas() {
      try {
        this.loading = true
        const data = await prjPlayerApi.gets({project_id: this.$store.getters.project, count: this.pageCount, page: this.currentPage, q: this.searchKeyword})
        this.tableData = data.rows
        this.total_nums = data.count
        this.loading = false
      } catch (error) {
        this.loading = false
        if (error.error_code === 10020) {
          this.tableData = []
        }
      }
    },
    back() {
      this.$emit('editClose')
    },
    // 切换table页
    async handleCurrentChange(val) {
      this.currentPage = val
      this.loading = true
      await this.getDatas()
      this.loading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  .header {
    padding: 0 30px;

    display: flex;
    justify-content: space-between;
    align-items: center;

    .title {
      height: 59px;
      line-height: 59px;
      color: $parent-title-color;
      font-size: 16px;
      font-weight: 500;
    }

    .filter-area {
      margin:0 5px;
    }

    .filter-title {
      font-size: 12px;
      margin-right: 5px;
    }
  }

  .header-right {
    float: right;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .pagination {
    display: flex;
    justify-content: flex-end;
    margin: 20px;
  }

  .back {
    margin-left: 20px;
    cursor: pointer;
  }
}
</style>
